/**
 * 示例第三方面板
 *
 * 演示第三方 Mod 如何提供一个 UI 组件注册到用户中心。
 */
import * as React from 'react';
/**
 * 示例面板组件
 */
export function SampleSlotPanel(_props) {
    const [count, setCount] = React.useState(0);
    return React.createElement('div', { className: 'sample-slot-panel' }, React.createElement('h2', { className: 'panel-title' }, '示例第三方面板'), React.createElement('div', { className: 'panel-content' }, React.createElement('p', null, '这是由 sample-slot-client-mod 注册的 slot 内容。'), React.createElement('p', null, `当前计数: ${count}`), React.createElement('button', { onClick: () => setCount(c => c + 1) }, '点击 +1')));
}
//# sourceMappingURL=sample-slot-panel.js.map